import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'

// Magic modal
export const Container = styled.div`
  pointer-events: all;
  display: flex;
  align-items: center;
  background-color: ${Colors.Neutral100};
  border-radius: 8px;
  padding: 12px 16px;

  ${Media.Phone`
    width: 300px;
  `};
`

export const Text = styled.div`
  ${Typography.Caption};
  color: ${Colors.White};
`
